<template>
  <div>
    <div v-if="applyShow == false">
      <div class="cooper_banner" :style="{backgroundImage: `url(${banner02Icon})`}">
        <div class="cooper_banner_wrap">
          <p style="font-size: 48px;color: #FFFFFF;letter-spacing: 6px;line-height: 1em">安预在线合作伙伴招募中</p>
          <p style="font-size: 20px;color: #ffffff;max-width: 680px;letter-spacing: 5px;padding-top: 45px;line-height: 36px">安预在线是自主研发基于SaaS模式的打造一站式在线教育平台 满足各个行业的机构、企业以及个人的培训需求</p>
          <button class="cooper_banner_btn" @click="apply">我要申请</button>
        </div>
      </div>
      <div class="cooper_01" :style="{backgroundImage: `url(${bgi02})`}">
        <img :src="youshi"/>
        <div class="cooper_01_con">
          <div v-for="(ite, ind) in list_info" :key="ind" class="cooper_01_ite">
            <img :src="ite.icon"/>
            <p>{{ite.title}}</p>
            <p>{{ite.instro}}</p>
          </div>
        </div>
      </div>
      <div class="cooper_02" :style="{backgroundImage: `url(${dotBgi})`}">
        <img :src="liucheng"/>
        <div class="cooper_02_con">
          <!-- 1 -->
          <div class="cooper_02_ite">
            <div class="cooper_02_ite_c">
              <img :src="i7"/>
            </div>
            <p>填申请表</p>
          </div>
          <div style="position: relative; top: 89px">
            <img :src="i12"/>
          </div>
          <!-- 2 -->
          <div class="cooper_02_ite" style="top: 68px">
            <div class="cooper_02_ite_c">
              <img :src="i2"/>
            </div>
            <p>电话沟通</p>
          </div>
          <div style="position: relative; top: 89px">
            <img :src="i11"/>
          </div>
          <!-- 3 -->
          <div class="cooper_02_ite">
            <div class="cooper_02_ite_c">
              <img :src="i3"/>
            </div>
            <p>洽谈细节</p>
          </div>
          <div style="position: relative; top: 89px">
            <img :src="i12"/>
          </div>
          <!-- 4 -->
          <div class="cooper_02_ite" style="top: 68px">
            <div class="cooper_02_ite_c">
              <img :src="i1"/>
            </div>
            <p>签约合作</p>
          </div>
          <div style="position: relative; top: 89px">
            <img :src="i11"/>
          </div>
          <!-- 4 -->
          <div class="cooper_02_ite">
            <div class="cooper_02_ite_c">
              <img :src="i6"/>
            </div>
            <p>1v1售后服务</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="applyShow == true">
      <Apply @ret="()=>{this.applyShow=false}"/>
    </div>
  </div>
</template>

<script>
import Banner02Icon from "@/assets/banner02.png"
import DotBgi from "@/assets/dotBgi.png"
import Bgi02 from "@/assets/bgi02.png"
import Youshi from "@/assets/youshi.png"
import Liucheng from "@/assets/liucheng.png"
import I1 from "@/assets/i1.png"
import I2 from "@/assets/i2.png"
import I3 from "@/assets/i3.png"
import I4 from "@/assets/i4.png"
import I5 from "@/assets/i5.png"
import I6 from "@/assets/i6.png"
import I7 from "@/assets/i7.png"
import I8 from "@/assets/i8.png"
import I9 from "@/assets/i9.png"
import I10 from "@/assets/i10.png"
import I11 from "@/assets/i11.png"
import I12 from "@/assets/i12.png"
import I13 from "@/assets/i13.png"
import I14 from "@/assets/i14.png"
import Apply from "./apply.vue"
export default {
  name: "cooperation",
  components: {
    Apply
  },
  data () {
    return {
      banner02Icon: Banner02Icon,
      dotBgi: DotBgi,
      bgi02: Bgi02,
      youshi: Youshi,
      liucheng: Liucheng,
      i1: I1,
      i2: I2,
      i3: I3,
      i4: I4,
      i5: I5,
      i6: I6,
      i7: I7,
      i8: I8,
      i9: I9,
      i10: I10,
      i11: I11,
      i12: I12,
      i13: I13,
      i14: I14,

      //
      list_info: [
        { "icon": I10, "title": "多端同步学习", "instro": "支持APP、小程序、HTML5、pc学习端", },
        { "icon": I9, "title": "系统化培训", "instro": "多种教学和助学工具，进行差异式系统化得教学培训", },
        { "icon": I8, "title": "官方推荐", "instro": "获得河北省人社厅官方指定得工伤预防在线培训平台", },
        { "icon": I5, "title": "开发团队", "instro": "经验与技术并存，为平台提供强大得安全保障", },
        { "icon": I4, "title": "持续迭代", "instro": "7×24小时得实时监管，应对突发状况，保证课持续性的更新迭代", },
      ],

      applyShow: false
    }
  },
  methods: {
    apply () {
      this.applyShow = true
    }
  }
};
</script>

<style scope>
.cooper_banner {
  width: 100%;
  height: 34.27vw;
  min-height: 659px;
  background-position: center;
  background-size: cover;
}
.cooper_banner_wrap {
  padding-left: 22.65%;
  padding-top: 186px;
}
.cooper_banner_btn {
  width: 198px;
  background: #FFFFFF;
  box-shadow: 0px 1px 4px 0px rgba(66, 66, 66, 0.34);
  border: 0;
  border-radius: 100px;
  letter-spacing: 3px;
  font-size: 20px;
  color: #515151;
  padding: 15px 37px;
  margin-top: 89px;
  cursor: pointer;
}
.cooper_01 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 564px;
  background-size: cover;
  background-position: center;
  padding-top: 71px;
}
.cooper_01_con {
  display: flex;
  padding-top: 47px;
}
.cooper_01_ite {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 219px;
  height: 298px;
  background: #FFFFFF;
  box-shadow: 0px 0px 11px 0px rgba(64, 77, 136, 0.14);
  padding: 36px 31px 24px 31px;
  margin: 0 13px;
}
.cooper_01_ite img {
  width: auto;
  height: 58.77px;
}
.cooper_01_ite p {
  line-height: 2;
}
.cooper_01_ite p:nth-child(2) {
  font-size: 24px;
  color: #515151;
  margin-top: 44px;
  line-height: 0;
  padding-bottom: 30px;
}
.cooper_01_ite p:nth-child(3) {
  font-size: 16px;
  color: #7E7E7E;
  text-align: center;
}
.cooper_02 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 599px;
  background-size: cover;
  background-position: center;
  padding-top: 71px;
}
.cooper_02_con {
  display: flex;
  margin-top: 77px
}
.cooper_02_ite {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cooper_02_ite p {
  font-size: 24px;
  color: #515151;
  margin-top: 30px;
}
.cooper_02_ite_c {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 153px;
  height: 153px;
  background-color: #fff;
  box-shadow: 0px 0px 23px 0px rgba(196, 202, 232, 0.35);
  border-radius: 50%;
}
.cooper_02_ite_c img {
  width: 69px;
  height: 69px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/cooperation.vue